import * as React from "react";

const styles = require('./AssetClassHeader.pcss');

interface LProps{
    assetClassName?: any;
    key?: string;
    title?: string;
}

export class AssetClassHeader extends React.Component<LProps, {}>{
    constructor(){
        super();
    }

    render(){
        return(
            <tr>
                <td className={styles.first_Row_Header} colSpan={10}>{this.props.title}</td>
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./src/client/Rankia/Components/AssetClassHeader/AssetClassHeader.tsx